<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.selectionCriteria }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDate"
                            :label="labels.tranDate"
                            :data-vv-as="labels.tranDate"
                            data-vv-name="tranDate"
                            :error-messages="errors.collect('tranDate')"
                            v-validate="doValidateDate"
                            ref="tranDate"
                            :max="new Date()"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6> </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.comDate"
                            :label="labels.comDate"
                            :data-vv-as="labels.comDate"
                            data-vv-name="comDate"
                            :error-messages="errors.collect('comDate')"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6> </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-text-field
                            v-model="forms.insdRefNo"
                            :label="labels.insdRefNo"
                            :error-messages="errors.collect('forms.insdRefNo')"
                            data-vv-name="forms.insdRefNo"
                            :data-vv-as="labels.insdRefNo"
                            clearable
                            readonly
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showInsuredHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6> </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-checkbox
                            :label="labels.sendToPrinter"
                            v-model="forms.sendToPrinter"
                            :error-messages="errors.collect('sendToPrinter')"
                            data-vv-name="sendToPrinter"
                            :data-vv-as="labels.sendToPrinter"
                            :disabled="query"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6> </v-flex>
                        <v-flex xs12 sm6 md6 lg6></v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.filters }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <!-- Transaction Type -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="forms.tranType"
                            :label="labels.tranType"
                            :error-messages="errors.collect('tranType')"
                            data-vv-name="tranType"
                            :data-vv-as="labels.tranType"
                            append-icon="mdi-magnify"
                            @click:append="multiTranTypeList = true"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>

                        <!-- Department -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="forms.dept"
                            :label="labels.dept"
                            :error-messages="errors.collect('dept')"
                            :data-vv-as="labels.dept"
                            data-vv-name="dept"
                            append-icon="mdi-magnify"
                            @click:append="multiDeptList = true"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>

                        <!-- Branch -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="forms.branch"
                            :label="labels.branch"
                            :error-messages="errors.collect('branch')"
                            data-vv-name="branch"
                            :data-vv-as="labels.branch"
                            append-icon="mdi-magnify"
                            @click:append="multiBranchList = true"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>

                        <!-- Policy Type -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="forms.polType"
                            :label="labels.polType"
                            :error-messages="errors.collect('polType')"
                            :data-vv-as="labels.polType"
                            data-vv-name="polType"
                            append-icon="mdi-magnify"
                            @click:append="multiPolTypeList = true"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>

                        <!-- Scheme -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="forms.scheme"
                            :label="labels.scheme"
                            :error-messages="errors.collect('scheme')"
                            :data-vv-as="labels.scheme"
                            data-vv-name="scheme"
                            append-icon="mdi-magnify"
                            @click:append="multiSchemeList = true"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>

                        <!-- Policy Status -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="forms.polStat"
                            :label="labels.polStat"
                            :error-messages="errors.collect('polStat')"
                            :data-vv-as="labels.polStat"
                            data-vv-name="polStat"
                            append-icon="mdi-magnify"
                            @click:append="multiPolStatList = true"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>

                        <!-- Agent -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="forms.agent"
                            :label="labels.agent"
                            :error-messages="errors.collect('agent')"
                            :data-vv-as="labels.agent"
                            data-vv-name="agent"
                            append-icon="mdi-magnify"
                            @click:append="multiInterList = true"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>

                        <!-- User Id -->
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="forms.usrRefId"
                            :label="labels.usrRefId"
                            :error-messages="errors.collect('usrRefId')"
                            :data-vv-as="labels.usrRefId"
                            data-vv-name="usrRefId"
                            append-icon="mdi-magnify"
                            @click:append="multiUsrRefIdList = true"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 class="pt-3">
          <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSubmit">
            <v-icon left dark>mdi-arrow-right-bold-box</v-icon>
            {{ labels.release }}
          </v-btn>
          <v-btn class="ml-2" color="orange" dark type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory>
            <v-btn class="ml-2" text>
              <span>{{ labels.format }}</span>
              <v-icon :color="'red'">mdi-file-pdf</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="submitting" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-card-title primary-title>
          <div>
            <div class="headline">System Information</div>
            <span class="grey--text">An error occurred.</span>
          </div>
        </v-card-title>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Error Details:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showInsuredHelpList" width="1280px" persistent>
      <insured-help-list headerInfo="headers1" @close="showInsuredHelpList = false" @assign-insured-info="assignInsuredInfo"></insured-help-list>
    </v-dialog>

    <v-dialog v-model="multiTranTypeList" width="900px" persistent>
      <multi-tran-type-help-list :tranType="forms.tranType" @close="doClose" @doAssign="doAssignTranType($event)"></multi-tran-type-help-list>
    </v-dialog>

    <v-dialog v-model="multiDeptList" width="900px" persistent>
      <multi-dept-help-list :dept="forms.dept" @close="doClose" @doAssign="doAssignDepartment($event)"></multi-dept-help-list>
    </v-dialog>

    <v-dialog v-model="multiBranchList" width="900px" persistent>
      <multi-branch-help-list :brn="forms.branch" @close="doClose" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
    </v-dialog>

    <v-dialog v-model="multiPolTypeList" width="900px" persistent>
      <multi-pol-type-help-list :pt="forms.polType" @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-help-list>
    </v-dialog>

    <v-dialog v-model="multiSchemeList" width="900px" persistent>
      <multi-scheme-help-list :scheme="forms.scheme" @close="doClose" @doAssign="doAssignScheme($event)"></multi-scheme-help-list>
    </v-dialog>

    <v-dialog v-model="multiPolStatList" width="900px" persistent>
      <multi-pol-stat-help-list :polStat="forms.polStat" @close="doClose" @doAssign="doAssignPolStat($event)"></multi-pol-stat-help-list>
    </v-dialog>

    <v-dialog v-model="multiInterList" width="900px" persistent>
      <multi-intermediary-help-list
        :intr="forms.agent"
        intrGrp="10,11,20,25"
        helpListTitle="Agent HelpList"
        @close="doClose"
        @doAssign="doAssignIntermediary($event)"
      ></multi-intermediary-help-list>
    </v-dialog>

    <v-dialog v-model="multiUsrRefIdList" width="900px" persistent>
      <multi-usr-ref-id-help-list :userId="forms.usrRefId" @close="doClose" @doAssign="doAssignUsrRefId($event)"></multi-usr-ref-id-help-list>
    </v-dialog>

    <v-dialog v-model="printerList" width="450px" persistent>
      <printer-help-list @close="doClose" @doAssign="doAssignPrinter($event)"></printer-help-list>
    </v-dialog>

    <v-dialog v-model="promptExeJob" width="500px" persistent>
      <batch-job-scheduler
        v-if="promptExeJob"
        :skipValidate="batchForm.skipValidate"
        :jobKeys="forms"
        :showJobMode="false"
        @close="promptExeJob = false"
        @doPopulate="processBatch($event)"
      />
    </v-dialog>

    <warning v-model="promptResubmit" @ok="doAccept">
      <div>{{ warningMsg1 }}</div>
      <div class="queryValue" v-for="(item, index) in bchJobDetails" :key="index">{{ item }}</div>
      <div>{{ warningMsg2 }}</div>
    </warning>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import InsuredHelpList from '@/components/core/common/dialog/InsuredHelpList'
import MultiTranTypeHelpList from '@/components/core/common/dialog/MultiTranTypeHelpList.vue'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiSchemeHelpList from '@/components/core/common/dialog/MultiSchemeHelpList.vue'
import MultiPolStatHelpList from '@/components/core/common/dialog/MultiPolStatHelpList'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
import MultiUsrRefIdHelpList from '@/components/core/common/dialog/MultiUsrRefIdHelpList.vue'
import PrinterHelpList from '@/components/core/common/dialog/PrinterHelpList.vue'
import { isAfter, isBefore, isEqual } from 'date-fns'
import { removeTime } from '@/utils/date'
import BatchJobScheduler from '@/components/core/common/BatchJobScheduler'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'

export default {
  data() {
    return {
      labels: {
        selectionCriteria: 'Selection Criteria',
        tranDate: 'Transaction Dates on or before*',
        comDate: 'Commencement Date on or before',
        insdRefNo: 'Release Only this Insured’s Policies',
        filters: 'Filters',
        tranType: 'Transaction Type',
        dept: 'Department',
        branch: 'Branch',
        polType: 'Policy Type',
        scheme: 'Scheme',
        polStat: 'Policy Status',
        agent: 'Agent',
        usrRefId: 'User Id',
        release: 'Release Policy',
        export: 'Do not release, Export to',
        format: 'PDF',
        sendToPrinter: 'Send output to printer'
      },
      forms: {
        tranDate: null,
        comDate: null,
        insdRefNo: '',
        tranType: 'All',
        dept: 'All',
        branch: 'All',
        polType: 'All',
        scheme: 'All',
        polStat: 'All',
        agent: 'All',
        usrRefId: 'All',
        batchRel: false,
        printId: 0,
        sendToPrinter: true
      },
      valInsdRefNo: false,
      showInsuredHelpList: false,
      multiTranTypeList: false,
      multiDeptList: false,
      multiBranchList: false,
      multiPolTypeList: false,
      multiSchemeList: false,
      multiPolStatList: false,
      multiInterList: false,
      multiUsrRefIdList: false,
      printerList: false,
      submitting: false,
      showErrorDialog: false,
      trandaterange: {},
      displayPrinter: false,
      panel1: [0],
      miscparams: {}
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    tDateRange() {
      return this.trandaterange
    },
    doValidateDate() {
      return 'required|checkSystemDate|valTranDateRange:' + this.tDateRange.effDate + ',' + this.tDateRange.expDate
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonData('trandaterange', '100')
      await this.getDisplayPrinter()
      await this.getCommonData('miscparams')
      this.defaultSendToPrinter()
    },
    assignInsuredInfo(data) {
      this.forms.insdRefNo = data.insdRefNo
    },
    defaultSendToPrinter() {
      if (this.miscparams) {
        this.forms.sendToPrinter = this.miscparams.sendToPrinter
      }
    },
    doClose() {
      this.multiTranTypeList = false
      this.multiDeptList = false
      this.multiBranchList = false
      this.multiPolTypeList = false
      this.multiSchemeList = false
      this.multiPolStatList = false
      this.multiInterList = false
      this.multiUsrRefIdList = false
      this.printerList = false
    },
    doAssignTranType(Obj) {
      this.forms.tranType = []
      this.forms.tranType = Obj.finalSelectedItems.toString()
    },
    doAssignDepartment(Obj) {
      this.forms.dept = []
      this.forms.dept = Obj.finalSelectedItems.toString()
    },
    doAssignBranch(Obj) {
      this.forms.branch = []
      this.forms.branch = Obj.finalSelectedItems.toString()
    },
    doAssignPolType(Obj) {
      this.forms.polType = []
      this.forms.polType = Obj.finalSelectedItems.toString()
    },
    async doAssignScheme(Obj) {
      this.forms.scheme = []
      this.forms.scheme = Obj.finalSelectedItems.toString()
    },
    doAssignPolStat(Obj) {
      this.forms.polStat = []
      this.forms.polStat = Obj.finalSelectedItems.toString()
    },
    async doAssignIntermediary(Obj) {
      this.forms.agent = []
      this.forms.agent = Obj.finalSelectedItems.toString()
    },
    async doAssignUsrRefId(Obj) {
      this.forms.usrRefId = []
      this.forms.usrRefId = Obj.finalSelectedItems.toString()
    },
    async doAssignPrinter(Obj) {
      this.forms.printId = Obj.printId
      this.forms.batchRel = true
      this.processBatchPolicyRelease()
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.displayPrinter === false) {
            this.forms.batchRel = true
            if (this.isBatchManager === true) {
              this.promptExeJob = true
            } else {
              this.processBatchPolicyRelease()
            }
          } else {
            this.printerList = true
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.forms.batchRel = false
          this.processBatchPolicyRelease()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processBatchPolicyRelease() {
      const apiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.processBatchPolicyRelease
      if (apiUrl) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiUrl, this.forms)

          if (result.data) {
            if (this.forms.batchRel) {
              this.$toast.success('Job successfully submitted to batch job process.')
            } else {
              this.$toast.success('Process completed.')
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async processBatch(bmgForms) {
      const apiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.exeBatchBatchPolicyRelease
      if (apiUrl) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiUrl, bmgForms)
          if (result.data) {
            const { data } = result.data
            if (data.prevBchJobs && data.prevBchJobs.length > 0) {
              this.promptResubmit = true
              this.getBchJobDetails(data.prevBchJobs)
            }
            this.submitting = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      this.batchForm.skipValidate = false
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  created() {
    this.$validator.extend('valTranDateRange', {
      getMessage(field, args) {
        return 'Date is not within permitted Date Range. Please check the Transaction Date Range parameters. (17)'
      },
      validate(value, args) {
        let effDate = args[0]
        let expDate = args[1]
        if (value) {
          return (isAfter(removeTime(value), removeTime(effDate)) || isEqual(removeTime(value), removeTime(effDate))) &&
          (isBefore(removeTime(value), removeTime(expDate)) || isEqual(removeTime(value), removeTime(expDate)))
        } else return true
      }
    })
  },
  mixins: [MessageMixin, commonAjaxMixin, batchManagerMixin],
  components: {
    InsuredHelpList,
    MultiTranTypeHelpList,
    MultiPolTypeHelpList,
    MultiBranchHelpList,
    MultiDeptHelpList,
    MultiPolStatHelpList,
    MultiIntermediaryHelpList,
    MultiSchemeHelpList,
    MultiUsrRefIdHelpList,
    PrinterHelpList,
    BatchJobScheduler
  }
}
</script>

<style>
</style>
